/**
 * Force English label + keep Buy it now button in sync after Shopify injects it.
 */
class GltheaaProductBuy extends HTMLElement {
  connectedCallback() {
    this.label = this.dataset.buyItNowLabel || 'Buy it now';
    this.observer = new MutationObserver(() => this.applyLabel());
    this.observer.observe(this, { childList: true, subtree: true });
    this.applyLabel();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  applyLabel() {
    this.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((button) => {
      if (button.dataset.gltheaaBuyLabel === this.label) return;
      button.textContent = this.label;
      button.dataset.gltheaaBuyLabel = this.label;
    });
  }
}

customElements.define('gltheaa-product-buy', GltheaaProductBuy);
